
export function isTextEmpty(text) {
    
    if(text === null || text.trim() === ""){
        return false;
    }
    return true;
}

export const roundUp = (num, decimals = 0) => {
    const factor = Math.pow(10, decimals);
    return Math.round(num * factor) / factor;
};